export const environment = {
  production: true,

  // USED FOR BANNER
  isProduction: true,

  // 180000 THREE MINUTES
  autoSaveTimout: 180000,

  showSectors: false,
  videoDocBuilderGuidanceViewer: 'https://clientviewerui.peninsulagrouponline.com/main?sessionid=',
  forceOpenWordDocsInClientApp: true, // TODO REMOVE?
  uploadColumn: true,

  // MSAL CONFIGURATION
  msal: {
    clientId: 'a0fbce25-0bc3-466e-bb45-b1880ae6ecd8',
    authority: 'f6aec7ed-3b3a-4826-99e1-1b3134e6b856',
    redirectUri: 'https://groupdocbuilderui.peninsulagrouponline.com',
    api: 'api://e04254cc-cb86-423d-9479-c4a7b22d1198'
  },

  // NEW API
  api: 'https://prod-groupdocumentbuilderapi.peninsulagrouponline.com',
};
